import {CTABanner} from '@primer/react-brand/esm'
import type {Document} from '@contentful/rich-text-types'
import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {renderWithoutParagraphs} from '../../utils'
import {resolveTestimonialLogo} from './resolve-testimonial-logo'
import type {TestimonialLogo} from './resolve-testimonial-logo'

export type FlexSuiteTestimonialBannerProps = {
  quote?: Document
  link?: {href: string; text: string}
  logo?: TestimonialLogo
  image?: Asset
}

export function FlexSuiteTestimonialBanner({quote, link, logo, image}: FlexSuiteTestimonialBannerProps) {
  if (!quote) return null

  const resolvedLogo = resolveTestimonialLogo(logo)

  return (
    <CTABanner variant={image ? 'balanced' : 'default'} hasGridLines>
      {resolvedLogo && (
        <CTABanner.Logo>
          <img
            src={resolvedLogo.url}
            alt={resolvedLogo.alt}
            style={{maxWidth: 120, maxHeight: 40, width: 'auto', height: 'auto'}}
          />
        </CTABanner.Logo>
      )}
      <CTABanner.Heading size="5">{renderWithoutParagraphs(quote)}</CTABanner.Heading>
      {link && <CTABanner.Link href={link.href}>{link.text}</CTABanner.Link>}
      {image && <CTABanner.Image src={`${image.fields.file.url}?fm=webp&w=720`} alt={image.fields.description ?? ''} />}
    </CTABanner>
  )
}
